import { fromJS } from 'immutable';
const initialState = fromJS({});

export function onboarding(state = initialState, action) {
  switch (action.type) {
    case 'ONBOARDING_SUBMIT':
      return state.mergeDeep(fromJS(action.payload.companyUpdate));
    case 'CLEAR_STORES':
      return initialState;
    case 'SET_ONBOADING_FIELDS':
      if (state === initialState) return fromJS(action.payload);
      return Object.keys(action.payload).reduce((stateToReturn, key) => stateToReturn.set(key, action.payload[key]), state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/onboarding/onboarding-reducer.js